export default __webpack_public_path__ + "9dbcf107d871d68cc51ad4d9d8ef8975.png";